import { Typography } from "@mui/material";

export default function ReportingTools() {
  return <Typography>Admin Reporting Tools Page</Typography>;
}
